import React, {memo} from "react";
import {Button, Col, Row} from "react-bootstrap";
import {Link} from "react-router-dom";
import {handleOpenModalSurvey} from "../../../../redux/actions/modals/modalSurvey";
import {useDispatch, useSelector} from "react-redux";
import {
    actionChangeLoaderModalOrderDetails,
    actionChangeSelectOrderModalOrderDetails,
    actionChangeStatusShowModalOrderDetails
} from "../../../../redux/actions/modals/modalOrderDetails/modalOrderDetails";
import axios from "axios";
import {BASE_URL, ORDERS_DETAILS_POST} from "../../../../apis";
import qs from "querystring";

const CardMyOrder = (props) => {
    const {address, delivery_date, totalPrice, delivery_time, poll_status, poll_message, id, factor} = props.data.item;
    const {token} = useSelector(state => state.user);
    const dispatch = useDispatch();

    const handleOpenModal = () => {
        dispatch(handleOpenModalSurvey(true, id));
    };

    const handleMoreOrder = () => {
        handleGetOrderInApi();
        dispatch(actionChangeStatusShowModalOrderDetails(true));
    };

    const handleGetOrderInApi = () => {
        dispatch(actionChangeLoaderModalOrderDetails(true));
        axios({
            method: 'post',
            url: BASE_URL + ORDERS_DETAILS_POST,
            data: qs.stringify({
                order: id,
            }),
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': token
            },
        }).then((response) => {
            if (response.data.status === 'ok') {
                dispatch(actionChangeSelectOrderModalOrderDetails(response.data));
                dispatch(actionChangeLoaderModalOrderDetails(false));
            } else {
                dispatch(actionChangeLoaderModalOrderDetails(false));
            }
        });

    };
    return (
        <div className={'base-box-card-my-order'}>
            <div className={'box-card-my-order'}>
                <ul className={'list-data-card-my-order'}>
                    <li>
                        <span>
                            <b>شماره فاکتور</b>
                            <span>{id}</span>
                        </span>
                        <span className={'float-left'}>
                            <Link to={"https://fruitmruit.com/ci/factors/customers/" + factor} target="_blank"
                                  onClick={(event) => {
                                      event.preventDefault();
                                      window.open("https://fruitmruit.com/ci/factors/" + factor)
                                  }}>
                                <span className={'text-success'}>
                                مشاهده صورت حساب
                                </span>
                            </Link>
                        </span>
                    </li>
                    <li>
                        <span>مبلغ سفارش</span>
                        <span className={'float-left'}>
                            <span>{parseInt(totalPrice).toLocaleString()}</span>
                            <span> تومان</span>
                        </span>
                    </li>
                    <li>
                        <span>زمان ثبت سفارش</span>
                        <span className={'float-left'}>{delivery_date}</span>
                    </li>
                    <li>
                        <span>زمان ارسال</span>
                        <span className={'float-left'}>{delivery_time}</span>
                    </li>
                    <li>
                        <span>آدرس : </span>
                        <span>{address}</span>
                    </li>
                </ul>
                <div className={'box-access-card-my-order'}>
                    <Row>
                        <Col xs={6}><Button variant="success" className={'base-btn-green btn-sm'} block
                                            disabled={!poll_status}
                                            onClick={handleOpenModal}>{poll_message}</Button></Col>
                        <Col xs={6}><Button variant="success" className={'base-btn-green btn-sm'} block
                        onClick={handleMoreOrder}>جزییات
                            سفارش</Button></Col>
                    </Row>

                </div>
            </div>
        </div>
    );
};

export default memo(CardMyOrder);
